import RiskCalcStatusService from '@Services/Risk/Risk.services';
import { RiskCalcStatusResult } from '@Types/risk.types';

export default class RiskCalcStatus {
	static readonly CalcStatusPollingInterval: number = 5 * 1000;
	static timerId?: number;
	public static cancelPollForCalcStatus = async () => {
		if (RiskCalcStatus.timerId) {
			global.clearTimeout(RiskCalcStatus.timerId);
			RiskCalcStatus.timerId = undefined;
		}
	};

	public static pollForCalcStatus = async (
		token: string,
		configId: string,
		update: (
			status: RiskCalcStatusResult,
			previousStatus?: RiskCalcStatusResult,
		) => boolean,
		start?: number,
		previousStatus?: RiskCalcStatusResult,
	): Promise<void> => {
		const oldTimerId = RiskCalcStatus.timerId;

		if (oldTimerId) clearTimeout(oldTimerId);

		if (!start) {
			start = new Date().getTime();
		}

		try {
			const calcStatusService = new RiskCalcStatusService(
				token,
				configId,
			);
			const statusResponse = await calcStatusService.getProcessStatus();
			const carryOn = update(statusResponse.calcStatus, previousStatus);
			// Check another timer has not been started while we are waiting.
			if (
				carryOn &&
				(!oldTimerId || oldTimerId === RiskCalcStatus.timerId)
			) {
				RiskCalcStatus.timerId = global.setTimeout(
					RiskCalcStatus.pollForCalcStatus,
					RiskCalcStatus.CalcStatusPollingInterval,
					token,
					configId,
					update,
					start,
					statusResponse.calcStatus,
				);
			}
		} catch (e) {
			update('error');
		}
	};
}
